function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#222",
  d: "M13.2277315,5.5564281 L15.7277315,5.5564281 L15.7277315,7.5564281 L7.72773155,7.5564281 L7.72773155,5.5564281 L10.2277315,5.5564281 L10.2277315,2.0564281 C10.2277315,1.22800097 10.8993044,0.556428099 11.7277315,0.556428099 C12.5561587,0.556428099 13.2277315,1.22800097 13.2277315,2.0564281 L13.2277315,5.5564281 Z M12.7277315,13.3439867 L12.7277315,9.5564281 L10.7277315,9.5564281 L10.7277315,15.3439867 L12.7277315,13.3439867 Z M9.72773155,8.5564281 L13.7277315,8.5564281 L13.7277315,20.2536525 C13.7277315,20.4510774 13.6692935,20.6440851 13.5597818,20.8083527 L12.5597818,22.3083527 C12.2534294,22.7678813 11.63256,22.8920552 11.1730314,22.5857028 C11.0631791,22.5124679 10.9689161,22.4182049 10.8956813,22.3083527 L9.89568126,20.8083527 C9.78616958,20.6440851 9.72773155,20.4510774 9.72773155,20.2536525 L9.72773155,8.5564281 Z",
  transform: "rotate(45 11.728 11.728)"
});

var SvgEyedropper = function SvgEyedropper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyedropper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Eyedropper.92b33d05.svg";
export { ForwardRef as ReactComponent };